// @/utils/request.js
import axios from 'axios';
import config from './config';
import router from '@/router';
import store from '@/store';
import { Message } from 'element-ui';

// 创建 axios 实例
const request = axios.create({
  baseURL: config.baseURL,
  timeout: 15000
});

// 请求拦截器：统一附加 Authorization
request.interceptors.request.use(config => {
  // 兼容两种存储方式；token 可能带也可能不带 Bearer 前缀
  const token = localStorage.getItem('token') || store.state.token;
  if (token) {
    config.headers.Authorization = token.startsWith('Bearer ') ? token : `Bearer ${token}`;
  }
  return config;
}, error => {
  return Promise.reject(error);
});

// 响应拦截器
request.interceptors.response.use(response => {
  return response;
}, error => {
  const status = error.response && error.response.status;
  if (status === 401) {
    // 令牌过期或无效：清理本地登录态并跳转登录页
    // 注意：登录态由 vuex-persistedstate 持久化在 localStorage['vuex']，必须一并清除，
    // 否则只清 token 后刷新页面会恢复旧的过期登录态
    localStorage.removeItem('token');
    localStorage.removeItem('vuex');
    store.commit('clearUser');
    if (router.currentRoute.path !== '/login') {
      router.push('/login');
    }
  } else if (status >= 500) {
    Message.error('服务器开小差了，请稍后重试');
  }
  return Promise.reject(error);
});

export default request;
